import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-expand-arrow',
  templateUrl: './expand-arrow.component.html'
})
export class ExpandArrowComponent {
@Input() expanded?: boolean;
}
